/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Value_LedeInputs */

const en_pricing_page_value_lede = /** @type {(inputs: Pricing_Page_Value_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar, payments, plans, the directory and an app for your clients in one place, instead of a separate subscription for each.`)
};

const pl_pricing_page_value_lede = /** @type {(inputs: Pricing_Page_Value_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalendarz, płatności, plany, katalog i aplikacja dla podopiecznych w jednym miejscu, zamiast osobnej subskrypcji na każde z nich.`)
};

/**
* | output |
* | --- |
* | "Calendar, payments, plans, the directory and an app for your clients in one place, instead of a separate subscription for each." |
*
* @param {Pricing_Page_Value_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_value_lede = /** @type {((inputs?: Pricing_Page_Value_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Value_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_value_lede(inputs)
	return en_pricing_page_value_lede(inputs)
});